import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=689c5913&scoped=true"
import script from "./Updates.vue?vue&type=script&lang=js"
export * from "./Updates.vue?vue&type=script&lang=js"
import style0 from "./Updates.vue?vue&type=style&index=0&id=689c5913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689c5913",
  null
  
)

export default component.exports